import React from 'react'
import {Lang} from 'yougile-lang'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {IconButton} from '@components/common/base/buttons'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {cn} from '@containers/html-utils'

export const ShowParentTasks = (props: {
  onToggle: () => void
  opened?: boolean
  className?: string
}) => {
  const content = props.opened
    ? Lang.msg.subtask.closeSubtasks
    : Lang.msg.subtask.openSubtasks

  return (
    <Tooltip content={content} placement="bottom-start">
      <IconButton
        size={'small'}
        icon={'IconSubtask'}
        className={cn(props.className, 'mr-8')}
        color={'secondary'}
        onClick={e => {
          e.stopPropagation()
          props.onToggle()
          void Tracking.send(TrackingEvent.subtasksOpenTree)
        }}
      />
    </Tooltip>
  )
}
